import axios from "axios";
import { showAlert, handleRequestError } from "../../utils/alert";
import VMasker from "vanilla-masker";

export default () => ({
  isLoading: true,
  isSubmitting: false,

  profileForm: {
    name: "",
    email: "",
    document: "",
    phone: "",
    password: "",
    password_confirmation: "",
  },

  async initProfile() {
    const token = localStorage.getItem("jwt_token");
    if (!token) {
      window.location.href = "/client/login";
      return;
    }

    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    await this.loadProfileData();
  },

  // ================= DATA LOADING =================

  async loadProfileData() {
    this.isLoading = true;
    try {
      const response = await axios.get("/api/client/profile");
      const data = response.data.data;

      this.profileForm.name = data.name;
      this.profileForm.email = data.email;

      // Load and immediately mask the existing document if present for visualization
      if (data.document) {
        const fakeEvent = { target: { value: data.document } };
        const fakePhoneEvent = { target: { value: data.phone } };
        this.applyDisplayMask(fakeEvent);
        this.applyDisplayPhoneMask(fakePhoneEvent);
      } else {
        this.profileForm.document = "";
        this.profileForm.phone = "";
      }
    } catch (error) {
      handleRequestError(error, "Erro ao carregar dados do perfil.");
    } finally {
      this.isLoading = false;
    }
  },

  // ================= VISUAL MASKS =================

  /**
   * Applies mask only for viewing purposes on page load.
   *
   * @param {Event} event
   */
  applyDisplayMask(event) {
    const rawValue = event.target.value;

    if (!rawValue) {
      this.profileForm.document = "";
      return;
    }

    let onlyNumbers = rawValue.replace(/\D/g, "");

    if (onlyNumbers.length <= 11) {
      this.profileForm.document = VMasker.toPattern(
        onlyNumbers,
        "999.999.999-99",
      );
    } else {
      onlyNumbers = onlyNumbers.substring(0, 14);
      this.profileForm.document = VMasker.toPattern(
        onlyNumbers,
        "99.999.999/9999-99",
      );
    }
  },

  /**
   * Applies mask only for viewing purposes on page load.
   *
   * @param {Event} event
   */
  applyDisplayPhoneMask(event) {
    const rawValue = event.target.value;

    if (!rawValue) {
      this.profileForm.phone = "";
      return;
    }

    let onlyNumbers = rawValue.replace(/\D/g, "");

    if (onlyNumbers.length <= 14) {
      this.profileForm.phone = VMasker.toPattern(onlyNumbers, "(99)99999-9999");
    }
  },

  // ================= SUBMIT =================

  async submitProfile() {
    this.isSubmitting = true;
    try {
      // Build payload strictly with allowed fields
      const payload = {
        phone: this.profileForm.phone,
      };

      // Only send password fields if the user typed something
      if (this.profileForm.password) {
        payload.password = this.profileForm.password;
        payload.password_confirmation = this.profileForm.password_confirmation;
      }

      await axios.put("/api/client/profile", payload);

      showAlert("Perfil atualizado com sucesso!", "success");

      // Clear passwords fields after success to prevent accidental resubmissions
      this.profileForm.password = "";
      this.profileForm.password_confirmation = "";
    } catch (error) {
      handleRequestError(error, "Erro ao atualizar perfil.");
    } finally {
      this.isSubmitting = false;
    }
  },
});
